import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTABand({
  eyebrow = "Ready when you are",
  title = "Supercharge your bookings",
  sub = "See RentAnything configured for your fleet. 30-minute demo, no slides.",
  primaryLabel = "Book a Demo",
  primaryTo = "/contact",
  secondaryLabel = "Operator Login",
  secondaryTo = "https://operator.rentanything.ai/login",
  secondaryExternal = true,
}) {
  return (
    <section className="ra-section" data-testid="cta-band">
      <div className="ra-container">
        <div
          className="relative overflow-hidden rounded-3xl border border-ra-line p-10 sm:p-14 lg:p-16 shadow-card"
          style={{ background: "#F5F8FC" }}
        >
          {/* subtle brand-blue mesh — never a wall of color */}
          <div
            className="absolute inset-0 pointer-events-none"
            aria-hidden="true"
            style={{
              background:
                "radial-gradient(55% 55% at 100% 0%, rgba(130,180,195,0.30) 0%, rgba(130,180,195,0) 65%), radial-gradient(40% 40% at 0% 100%, rgba(245,158,11,0.10) 0%, rgba(245,158,11,0) 65%)",
            }}
          />
          {/* tiny coral asterisk sprinkle */}
          <span
            className="absolute right-8 top-8 text-ra-coral text-xl font-bold pointer-events-none select-none"
            aria-hidden="true"
          >
            ✦
          </span>

          <div className="relative max-w-2xl">
            <span className="ra-eyebrow">{eyebrow}</span>
            <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-ra-ink leading-[1.08]">
              {title}
            </h2>
            <p className="mt-4 text-base sm:text-lg text-ra-ink/70 max-w-xl">{sub}</p>
            <div className="mt-7 flex flex-wrap gap-3">
              <Link to={primaryTo} className="ra-btn-primary" data-testid="cta-band-primary-btn">
                {primaryLabel}
                <ArrowRight size={16} />
              </Link>
              {secondaryExternal ? (
                <a
                  href={secondaryTo}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ra-btn-ghost"
                  data-testid="cta-band-secondary-btn"
                >
                  {secondaryLabel}
                </a>
              ) : (
                <Link to={secondaryTo} className="ra-btn-ghost" data-testid="cta-band-secondary-btn">
                  {secondaryLabel}
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
